module.exports = __webpack_public_path__ + "static/media/Grenada.98189e64.png";